import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextField from 'material-ui/TextField';
import { common } from './../../../../../../data/constants';
import { formatMinutesToHoursWithMinutes } from './../../../../../../utilities/calendarUtilities';
import {
  formatCreditValue,
  formatStringToMinutes,
  rawCreditValue
} from './../../helpers';
import FilterWrapper from './../FilterWrapper';
import { useLanguage } from './../../../../../../context/LanguageContext';

class CreditRangeFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      startInclusive: null,
      endInclusive: null
    };

    this.lastUserInput = {
      startInclusive: null,
      endInclusive: null
    };
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    let { startInclusive, endInclusive } = nextProps;
    startInclusive =
      startInclusive && formatMinutesToHoursWithMinutes(startInclusive, 0);
    endInclusive =
      endInclusive && formatMinutesToHoursWithMinutes(endInclusive, 0);

    this.lastUserInput = {
      startInclusive: startInclusive && rawCreditValue(startInclusive),
      endInclusive: endInclusive && rawCreditValue(endInclusive)
    };

    this.setState({ startInclusive, endInclusive });
  }

  onCloseFilter = () => {
    let { startInclusive, endInclusive } = this.state;
    startInclusive = formatStringToMinutes(startInclusive) || null;
    endInclusive = formatStringToMinutes(endInclusive) || null;
    this.props.updateLocalFilterPayload({
      [this.props.filterKey]: {
        startInclusive,
        endInclusive
      }
    });
  };

  handleOnKeyPress = event => {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    }
    return true;
  };

  handleOnBlur = event => {
    const elementId = event.target.id;
    const state = { ...this.state };
    const formatedCreditInput = formatCreditValue(state[elementId]);

    this.lastUserInput[elementId] = rawCreditValue(formatedCreditInput);
    this.setState({ [elementId]: formatedCreditInput });
  };

  handleOnFocus = event => {
    const elementId = event.target.id;
    const lastUserInput = this.lastUserInput[elementId] || '';

    this.setState({ [elementId]: lastUserInput });
  };

  handleOnChange = event => {
    const enteredValue = event.target.value;
    const elementId = event.target.id;

    if (enteredValue.length <= 6) {
      this.setState({ [elementId]: enteredValue });
    }
  };

  render() {
    const filterWrapperProps = {
      changesInFilter: [
        this.state.startInclusive,
        this.state.endInclusive
      ].filter(item => item).length,
      id: this.props.id,
      isUserAdded: this.props.isUserAdded,
      name: this.props.name,
      onCloseFilter: this.onCloseFilter,
      removeFilter: this.props.removeFilter
    };

    return (
      <FilterWrapper {...filterWrapperProps}>
        <TextField
          id='startInclusive'
          className='search-field'
          floatingLabelText={this.props.FB_LABELS?.CREDIT?.MINIMUM || ''}
          style={{ fontSize: '12px' }}
          value={this.state.startInclusive || ''}
          onKeyPress={this.handleOnKeyPress}
          onBlur={this.handleOnBlur}
          onChange={this.handleOnChange}
          onFocus={this.handleOnFocus}
        />
        <TextField
          id='endInclusive'
          className='search-field'
          floatingLabelText={this.props.FB_LABELS?.CREDIT?.MAXIMUM || ''}
          style={{ fontSize: '12px', top: '-20px' }}
          value={this.state.endInclusive || ''}
          onChange={this.handleOnChange}
          onKeyPress={this.handleOnKeyPress}
          onBlur={this.handleOnBlur}
          onFocus={this.handleOnFocus}
        />
      </FilterWrapper>
    );
  }
}

CreditRangeFilter.propTypes = {
  endInclusive: PropTypes.number,
  filterKey: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  isUserAdded: PropTypes.bool,
  name: PropTypes.string.isRequired,
  removeFilter: PropTypes.func,
  startInclusive: PropTypes.number,
  updateLocalFilterPayload: PropTypes.func.isRequired,
  FB_LABELS: PropTypes.object
};

CreditRangeFilter.defaultProps = {
  endInclusive: null,
  isUserAdded: false,
  removeFilter: () => {},
  startInclusive: null,
  FB_LABELS: {}
};

function CreditRangeFilterWrapper(props) {
  const { labels } = useLanguage();
  return <CreditRangeFilter {...props} FB_LABELS={labels.FILTER_BAR} />;
}

export default CreditRangeFilterWrapper;
